import { getAlidaDomain } from './getAlidaDomain';
import type { Pod } from '$lib/types/Pod';
import { isDevelopment } from '$lib/utils/environmentResolver';

export const getAiLabsBaseUrl = (pod: Pod) => {
	const domain = getAlidaDomain(pod);
	const podName = isDevelopment(pod) ? 'sit1' : pod;

	return `https://ailabs-services.${podName}.${domain}.com` as const;
};
